import { styled } from 'assets/theme';
import React, { useEffect, useState } from 'react';
import { IColorColor } from '../modals/StudyModal';

const colorPickerColors = [
	'ffffff', 'ffd0cf', 'ffd9bb', 'fff56c', 'eaeba3', 'd3e8ae', 'adf3ec', 'ccdcfa', 'd9c3eb',
	'efefef', 'eb8b87', 'ffb679', 'ffe252', 'e2e485', 'c5e093', '9de3df', 'b1c9f8', 'c5a6e1',
	'cccccc', 'e36460', 'ff9250', 'ffcd2b', 'dcdf67', 'b3d987', '66cac4', '97b8f7', 'b387d7',
	'9b9b9b', 'dd3e39', 'ff6a23', 'faaf3a', 'c9d641', '8bc176', '33b9b0', '7da6f5', '9f6ace',
	'656565', 'b82c0b', 'be501b', 'e99b54', '97a030', '699158', '00a99d', '5f7cb8', '784f9a',
	'343434', '892008', '803512', 'ab611f', '646c20', '46603a', '007e76', '3e527a', '503567',
	'000000', '5c1506', '401a08', '714114', '333610', '222f1d', '00544f', '1f2a3c', '281a33',
];

interface IColorSwatchProps {
	changeState?: (state: boolean) => void,
	setColor: (color: string | IColorColor, type: string, name: string | undefined) => void,
	type: string,
	name?: string,
	isModal?: boolean,
	top: number,
	color: string,
}

export const ColorSwatch: React.FunctionComponent<IColorSwatchProps> = ({ changeState, setColor, type, name, isModal, top, color }) => {
	const [colors] = useState(colorPickerColors)
  const [currentColor, setCurrentColor] = useState<string>(color);
	const [pickingColor, setPickingColor] = useState(false)

	const chooseColor = (newColor: string) => {
		if (changeState) {
			changeState(false)
		}
    setPickingColor(false)
    setCurrentColor(`#${newColor}`)
		setColor(newColor, type, name)
	}

	useEffect(() => {
		if (changeState) {
			changeState(pickingColor)
		}
	}, [pickingColor, changeState])

	const togglePicker = () => {
		setPickingColor(b => !b);
	}

	const colorsListItemClickHandler = (e: React.MouseEvent<HTMLSpanElement>) => {
		if (e.currentTarget.dataset.id) {
			chooseColor(e.currentTarget.dataset.id)
		}
	}

	const colorsList = colors.map((colorItem, i) => (
				<Color
						key={`${color}-${i}`}
						title={`#${colorItem}`}
						color={colorItem}
						data-id={colorItem}
						onClick={colorsListItemClickHandler}
				/>
		)
);

	const pickerStyle = {
		display: pickingColor ? 'block' : 'none',
		left: isModal ? '-120px' : 0,
		top: top ? top : 0,
	};

	return (
		<div>
			<span>
				<Swatch
					id={`swatch ${name}`}
					color={currentColor === 'auto' ? 'white' : currentColor}
					className={`color-picker-swatch ${type}`}
					onClick={togglePicker}
				/>
			</span>
			<div id="colorPicker">
				<div className="color-picker-options" style={pickerStyle}>
					<ul>
						{colorsList}
					</ul>
				</div>
			</div>
		</div>
	);
}

const Swatch = styled.div`
  background-color: ${({ color }) => color};
`;
const Color = styled.li`
	background-color: #${({ color }) => color};
	height: 13px;
	width: 13px;
	border: 1px solid #aaaaaa;

	&:hover {
		cursor: pointer;
	}
`;
